'use strict';

module.exports = require('./react-bubble-chart-d3').default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@weknow/react-bubble-chart-d3/lib/index.js
// module id = 1428
// module chunks = 0